import { useState, useEffect, useContext } from "react";
import { Birthday } from "./components/Birthday";
import { Email } from "./components/Email";
import { Gender } from "./components/Gender";
import { Name } from "./components/Name";
import { ContextProfileUser } from "./lib/profileContext";
import { Password } from "./components/Password";
import { landingId, EventsSignIn } from "./constants";
import { simplyClick, getTTI, sendScreenResolution } from "./helpers";
import { useSessionData } from "ui-components";
import { Footer } from "./components/Footer";
import { createPortal } from "react-dom";
import { useAppendLandingId } from "./hooks/useAppendLandingId";

function App() {
  const [step, setStep] = useState(1);
  let content = null;

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);
  const footer = document.getElementById("footer");

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);


  useAppendLandingId(landingId);
  useEffect(() => {
    const signInButton = document.querySelector(".login_btn");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton?.setAttribute("href", `/login${lndId}`);
    }
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".login_btn");
    if (!signInButton) return;

    const handleClick = () => {
      const eventName = EventsSignIn[step];
      if (eventName) {
        simplyClick(eventName);
      }
    };

    signInButton.addEventListener("click", handleClick);

    return () => {
      signInButton.removeEventListener("click", handleClick);
    };
  }, [step]);

  useEffect(() => {
    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent?.trim() ?? "";
    let previousText = element.textContent?.trim() ?? "";

    const observer = new MutationObserver(() => {
      const currentText = element.textContent?.trim() ?? "";
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(async () => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    if (window.location.search !== "") {
      const signInButton = document.querySelector(".login");
      signInButton?.setAttribute("href", `/login/${window.location.search}`);
    }

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);

  switch (step) {
    case 1:
      content = (
        <>
          <Gender
            nextStep={() => setStep(2)}
            setData={setData}
            data={data}
          />
        </>
      );
      break;
    case 2:
      content = (
        <>
          <Birthday
            nextStep={() => setStep(3)}
            setData={setData}
            data={data}
          />
        </>
      );
      break;
    case 3:
      content = (
        <>
          <Name
            nextStep={() => setStep(4)}
            setData={setData}
            data={data}
          />
        </>
      );
      break;
    case 4:
      content = (
        <>
          <Email
            nextStep={() => setStep(5)}
            setData={setData}
            data={data}
          />
        </>
      );
      break;
    case 5:
      content = (
        <>
          <Password setData={setData} data={data} />
        </>
      );
      break;
    default: ;
  }

  return <div>
    {content}
    {footer && createPortal(<Footer step={step} />, footer)}
  </div>;
}

export default App;
